<template>

  <div>
      <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="../assets/Banner01.jpg" class="d-block w-100" alt="...">
          </div>
          <div class="carousel-item">
            <img src="../assets/Banner02.jpg" class="d-block w-100" alt="...">
          </div>
          <div class="carousel-item">
            <img src="../assets/Banner03.jpg" class="d-block w-100" alt="...">
          </div>
        </div>
      </div>





    <!--热销产品-->
<!--    <section class="feature-area section-padding5 section-padding4" style="background-color: rgba(6, 163, 232, 0.05)">-->
<!--      <div class="container">-->
<!--        <div class="title">-->
<!--          <div class="text">热销产品</div>-->
<!--        </div>-->

<!--        <div class="row" style="width: 80%; margin: auto; ">-->
<!--          <div class="col-lg-3 section-padding4 " v-for="(list,index) in hotProductList">-->
<!--            <div class="card div1 big-box">-->
<!--              <div class="">-->
<!--                <img :src="list.path" class="card-img-top" style="border-radius: 0.25rem" alt="">-->
<!--              </div>-->
<!--              <div class="card-body" style="border-top: 1px solid lightgrey">-->
<!--                <p class="card-text p2">{{list.name}}</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->

<!--    <section class="feature-area section-padding5 section-padding4">-->
<!--      <div class="container">-->
<!--          <div class="title">-->
<!--&lt;!&ndash;            <div class="line"></div>&ndash;&gt;-->
<!--            <div class="text">关于我们</div>-->
<!--&lt;!&ndash;            <div class="line"></div>&ndash;&gt;-->
<!--          </div>-->
<!--         <div class="row">-->
<!--           <div class="col-lg-5">-->
<!--             <img src="/static/assets/images/about.jpg">-->
<!--           </div>-->
<!--           <div class="col-lg-7" style="font-size: 1rem">-->
<!--             <p>北京泽浩天科技发展有限公司成立于2012年，坐落于北京市门头沟区永定河畔，比邻阜石路、西六环，交通十分便利，泽浩天总部设在北京，河北、四川、新疆均设有分公司。公司自创立之初就坚以信誉求发展为经营理念；以客户为中心的服务宗旨。-->

<!--               公司经过多年的潜心经营，一直活跃在科研院所、大专院校等诸多国家重点实验室；服务于第三方检测以及生物医疗企业，提供国内外知名品牌的实验室仪器、耗材等产品。现已发展成为一家以技术为本，拥有雄厚经济、精湛技术的高素质的专业实验设备耗材销售公司。与中国科学院、中国农业大学、北京大学、清华大学、中国农业科学院以及华大检测等等客户都有多年的合作基础，在合作过程中树立了良好的口碑和信誉。</p>-->

<!--             <button type="button" class="btn btn-secondary">查看更多</button>-->
<!--           </div>-->
<!--         </div>-->
<!--      </div>-->
<!--    </section>-->

    <!--代理品牌-->
<!--    <section class="feature-area section-padding5 section-padding4"  style="background-color: rgba(6, 163, 232, 0.05)">-->
<!--      <div class="container">-->
<!--        <div class="title">-->
<!--          &lt;!&ndash;            <div class="line"></div>&ndash;&gt;-->
<!--          <div class="text">代理品牌</div>-->
<!--          &lt;!&ndash;            <div class="line"></div>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-lg-4 section-padding4" v-for="(list, index) in brandList">-->
<!--            <img :src="list.image" style="width: 20rem;height: 7rem; margin: auto">-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->


    <!--新闻资讯-->
<!--    <section class="feature-area section-padding5 section-padding4">-->
<!--      <div class="container">-->
<!--        <div class="title wow fadeInUp">-->
<!--          <div class="text">新闻资讯</div>-->
<!--        </div>-->

<!--        <div class="rowFluid">-->
<!--          <div class="news_center_content">-->
<!--            <div class="span4 col-sm-12 wow fadeInDown" data-wow-delay="1.2s">-->
<!--              <div class="news_center_list">-->
<!--                <div class="news_center_list_img"> <img src="/static/assets/images/034.jpg" alt="公司新闻" /> </div>-->
<!--                <div class="news_center_list_title">公司新闻</div>-->
<!--                <ul>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/pingtaidongtai/5.html" class="span8 a" title="精密细胞培养振荡器荣获“用户青睐仪器”奖"><i class="fa fa-angle-right i"/>精密细胞培养振荡器荣获“用户青睐仪器”奖 </a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/pingtaidongtai/4.html" class="span8 a" title="教育部将支持高校建设高等级生物安全实验室"><i class="fa fa-angle-right i"></i>教育部将支持高校建设高等级生物安全实验室 </a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/pingtaidongtai/3.html" class="span8 a" title="基因扩增仪的三个基本反应步骤介绍"><i class="fa fa-angle-right i"></i>基因扩增仪的三个基本反应步骤介绍 </a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/pingtaidongtai/2.html" class="span8 a" title="摇床的正确使用方法分享"><i class="fa fa-angle-right i"></i>摇床的正确使用方法分享 </a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/pingtaidongtai/1.html" class="span8 a" title="简述使用超微量分光光度计时应注意的事项"><i class="fa fa-angle-right i"></i>简述使用超微量分光光度计时应注意的事项 </a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->

<!--                </ul>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="span4 col-sm-12 wow fadeInUp" data-wow-delay="0.7s">-->
<!--              <div class="news_center_list">-->
<!--                <div class="news_center_list_img"> <img src="/static/assets/images/035.jpg" /> </div>-->
<!--                <div class="news_center_list_title">行业资讯</div>-->
<!--                <ul>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/bangzhuzhongxin/21.html" class="span8 a" title="一文与大家分享医用冰箱的使用管理制度"><i class="fa fa-angle-right"></i>一文与大家分享医用冰箱的使用管理制度</a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/bangzhuzhongxin/20.html" class="span8 a" title="还不知道如何使用转速可调高速迷你离心机？进来看"><i class="fa fa-angle-right"></i>还不知道如何使用转速可调高速迷你离心机？进来看 </a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/bangzhuzhongxin/19.html" class="span8 a" title="基因扩增仪保证了实验快速准确"><i class="fa fa-angle-right"></i>基因扩增仪保证了实验快速准确 </a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/bangzhuzhongxin/18.html" class="span8 a" title="这些会影响国产实验室器皿清洗机清洗效果的因素您知道吗？"><i class="fa fa-angle-right"></i>这些会影响国产实验室器皿清洗机清洗效果的因素您知道吗？ </a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/bangzhuzhongxin/17.html" class="span8 a" title="浅述国产实验室冻干机的提取原则及提取方法"><i class="fa fa-angle-right"></i>浅述国产实验室冻干机的提取原则及提取方法 </a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->

<!--                </ul>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="span4 col-sm-12 wow fadeInDown" data-wow-delay="1.3s">-->
<!--              <div class="news_center_list">-->
<!--                <div class="news_center_list_img"> <img src="/static/assets/images/036.jpg" /> </div>-->
<!--                <div class="news_center_list_title">常见问题</div>-->
<!--                <ul>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/xingyexinwen/16.html" class="span8 a" title="六个步骤可将十万分之一电子天平设置完成"><i class="fa fa-angle-right"></i>六个步骤可将十万分之一电子天平设置完成 </a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/xingyexinwen/15.html" class="span8 a" title="安装艺斯高生物安全柜所需要达到的要求如下"><i class="fa fa-angle-right"></i>安装艺斯高生物安全柜所需要达到的要求如下</a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/xingyexinwen/14.html" class="span8 a" title="十万分之一电子天平的称量方法分享"><i class="fa fa-angle-right"></i>十万分之一电子天平的称量方法分享</a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/xingyexinwen/13.html" class="span8 a" title="国产实验室冻干机使用过后的消毒灭菌方法"><i class="fa fa-angle-right"></i>国产实验室冻干机使用过后的消毒灭菌方法</a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->
<!--                  <li class="span12"> <a href="/a/xinwenzixun/xingyexinwen/12.html" class="span8 a" title="浅述进口移液器的电池使用技巧"><i class="fa fa-angle-right"></i>浅述进口移液器的电池使用技巧</a>-->
<!--                    <div style="font-size: 12px; color: #ccc; float: right; margin-top: 3px;">10-01</div>-->
<!--                  </li>-->

<!--                </ul>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->

    <section class="feature-area section-padding5 section-padding4">
      <div class="container">
<!--        <div class="title wow fadeInUp">-->
<!--          <div class="text">新闻资讯</div>-->
<!--        </div>-->

        <div class="rowFluid">
          <div class="news_center_content">
            <div class="span4 col-sm-12 wow fadeInDown" data-wow-delay="1.2s">
              <div class="news_center_list" @click="toNews()">
                <div class="news_center_list_img"> <img src="/static/assets/images/038.jpg" alt="公司新闻" /> </div>
                <div class="news_center_list_title">新闻资讯</div>
              </div>
            </div>
            <div class="span4 col-sm-12 wow fadeInUp" data-wow-delay="0.7s">
              <div class="news_center_list" @click="toProducts()">
                <div class="news_center_list_img"> <img src="/static/assets/images/034.jpg" /> </div>
                <div class="news_center_list_title">新品前言</div>

              </div>
            </div>
            <div class="span4 col-sm-12 wow fadeInDown" data-wow-delay="1.3s">
              <div class="news_center_list" @click="toAbout()" style="">
                <div class="news_center_list_img"> <img src="/static/assets/images/037.jpg" /> </div>
                <div class="news_center_list_title">关于我们</div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        hotProductList: [],
        brandList: [],
      }
    },
    methods: {
      // 获取产品数据
      getHotProducts() {
        const vm = this;

        vm.$_axios({
          method: 'post',
          url: '/mapis/product/getHotProducts',
          needLogin: false,
        }).then((response) => {
          if (response.status === 200) {
            const responseData = response.data.data;
            console.log(responseData);
            vm.hotProductList = responseData;
          }
        });
      },

      // 获取产品数据
      getProducts2(id) {
        const vm = this;
        console.log(id)
        vm.$_axios({
          method: 'post',
          url: '/mapis/product/getProducts',
          params: {
            parentId: id
          },
          needLogin: false,
        }).then((response) => {
          // console.log(response,"呵呵呵呵呵呵呵呵呵")
          if (response.status === 200) {
            const responseData = response.data.data;
            console.log(responseData);
            vm.productList = responseData;
            vm.$router.push({name:'products',query:{parentId:id, s:Math.random()}});
          }
        });
      },

      //获取产品详情
      toProductDetails(product){
        const vm = this;
        vm.$_storage.setLocalStore('product',product);
        vm.$router.push({name:'productDetails'});
      },
      //获取产品详情
      toNews(){
        const vm = this;
        vm.$router.push({name:'news'});
      },
      //获取产品详情
      toProducts(){
        const vm = this;
        vm.$router.push({name:'products'});
      },
      //获取产品详情
      toAbout(product){
        const vm = this;
        vm.$router.push({name:'about'});
      },

      // 获取产品数据
      getBrands() {
        const vm = this;

        vm.$_axios({
          method: 'post',
          url: '/mapis/brand/getBrands',
          needLogin: false,
        }).then((response) => {
          if (response.status === 200) {
            const responseData = response.data.data;
            console.log(responseData);
            vm.brandList = responseData;
          }
        });
      },
    },
    created() {
      let vm = this;

    },
    mounted() {
      let vm = this;
      // vm.getHotProducts();
      vm.getBrands();
    },
  };
</script>




// WEBPACK FOOTER //
// Home.vue?6448cdd2